export default __webpack_public_path__ + "static/media/landing.13710a6a.png";